<template>
    <div class="closeTemplate-detail">
        <el-form ref="closeTemplateForm" :rules="rules" :model="closeTemplate" size="mini" label-width="120px" class="closeTemplate-form">
            <el-row>
              <el-col :span="19">
                    <el-form-item label="模板名称" prop="templateName">
                        <el-input v-if="isRead" disabled  v-model="closeTemplate.templateName"></el-input>
                        <el-input v-else :readonly="isRead && !(isInstance && ifConfig)" v-model="closeTemplate.templateName"></el-input>
                    </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-button v-if="isInstance && ifConfig" style="margin-left:20px;" title='添加闭环条件' type="primary" icon="el-icon-plus" circle @click="handleAddCondition()"></el-button>
                <el-button v-if="isInstance && ifConfig"  title='保存闭环条件' type="primary" icon="el-icon-setting" circle @click="handleCloseTemplateFormSave(true)"></el-button>
                <el-button v-if="isInstance && ifConfig"  title='查看闭环BI' type="primary" icon="el-icon-s-data" circle @click="handleClosedLoopBI()"></el-button>
              </el-col>
            </el-row>
             <el-row v-if="!isInstance">
                    <el-form-item label="模板描述" prop="templateDes">
                      <el-input v-if="isRead" disabled v-model="closeTemplate.templateDes" style="width:101%;overflow-x:hidden;"  type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                      <el-input v-else v-model="closeTemplate.templateDes" style="width:101%;overflow-x:hidden;"  type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                  </el-form-item>
            </el-row>
            <el-row v-if="!isRead">
                <el-form-item label="闭环列表" prop="nodes">
                    <TaskNode :loadTimer="loadTimer"  ref="taskNodeRef" :isInstance="isInstance" :ifConfig="ifConfig" :taskNodes="closeTemplate.nodes" @editNode="editNode"/>
                </el-form-item>
            </el-row> 
            <el-row v-if="isRead">
                <el-form-item label="闭环列表" prop="nodes">
                    <el-table :data="closeTemplate.nodes" style="width: 100%">
                        <el-table-column  prop="label"  label="闭环条件"></el-table-column>
                        <el-table-column  prop="status" label="状态" >
                              <template slot-scope="scope">
                                <el-tag  v-if="scope.row.status === 0" type="info" size="small">未闭环</el-tag>
                                <el-tag  v-if="scope.row.status === 1" type="success" size="small">已闭环</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-row>
            </el-form>
            <el-dialog
              :fullscreen=true
              :visible.sync="isShowClosedLoopBI"
              append-to-body
              >
                <ClosedLoopRing ref="cosedLoopPie" :key="loadTimer" :currentProcess="currentProcess"/>
            </el-dialog>        
        </div>
    </template>

<script>
// eslint-disable-next-line standard/object-curly-even-spacing
import { saveProcessCloseTemplate, saveProcessInstanceCloseTemplate} from '@/data-model';
import mixinsNav from '@/mixins/mixins-nav';
// import { cloneDeep, isEmpty } from 'lodash';
import TaskNode from './TaskNode';
import ClosedLoopRing from '@/components/ClosedLoopRing';

export default {
    components: {
        TaskNode,
        ClosedLoopRing
    },
    mixins: [ mixinsNav ],
    data () {
        return {
            closeTemplate: {
                id: '',
                templateName: '',
                templateDes: '',
                nodes: []
            },
            taskNodesObj: [],
            loadTimer: '',
            currentProcess: {
                processInstanceId: '',
                processName: '',
                master: '',
                loopFinalState: ''
            },
            isShowClosedLoopBI: false,
            rules: {
                templateName: [
                    { required: true, message: '请输入模板名称', trigger: 'change' },
                    { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'change' }
                ]
            }
        };
    },
    props: {
        tableHeight: {
            type: Number,
            default: 280
        },
        isRead: {
            type: Boolean,
            default: false
        },
        ifConfig: {
            type: Boolean,
            default: false
        },
        instancesInfo: {
            type: Object
        },
        isInstance: {
            type: Boolean,
            default: false
        }
    },
    created () {
    },
    methods: {
        async _initPage (obj) {
            this.closeTemplate = obj;
            // // console.log(this.closeTemplate);
            // if (this.closeTemplate.id) {
            // // await this._initServiceTimeTreeList(this.timeconfig.processServiceId);
            // }
            this.loadTimer = new Date().getTime();
            // if (this.isInstance) {

            // }
        },
        async handleCloseTemplateFormSave () {
            let result = true;
            this.$refs['closeTemplateForm'].validate(async (valid) => {
                if (valid) {
                    this.saveData();
                } else {
                    result = false;
                }
            });
            return result;
        },
        async saveData () {
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // console.log(this.closeTemplate);
            if (this.isInstance) {
                this.closeTemplate.processInstanceId = this.instancesInfo.id;
                await saveProcessInstanceCloseTemplate(this.closeTemplate);
            } else {
                await saveProcessCloseTemplate(this.closeTemplate);
            }
            this.$emit('handleSearch');
            loading.close();
        },
        editNode (nodeList) {
            this.closeTemplate.nodes = nodeList;
        },
        handleAddCondition () {
            // setTimeout(() => {
            this.$refs.taskNodeRef.handleNodeAdd();
            // }, 0);
        },
        async handleClosedLoopBI () {
            this.loadTimer = new Date().getTime();
            this.isShowClosedLoopBI = true;
            this.currentProcess.processInstanceId = this.instancesInfo.id;
            this.currentProcess.processName = this.instancesInfo.name;
            this.currentProcess.master = this.instancesInfo.startedBy.trueName;
            // console.log( this.currentProcess);
            setTimeout(() => {
                // 调用子组件的方法
                this.$refs.cosedLoopPie._initPage();
            }, 100);
        }
    }
};
</script>

<style lang="less">
    .closeTemplate-detail {
        width: 100%;
        margin-top: -1%;
        margin-bottom: -2%;
        .closeTemplate-form {
            // width: 700px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/CloseTemplate/CloseTemplateDetail/CloseTemplateDetail.vue